export default "__VITE_ASSET__BNpmeDRV__"